import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../store/slices/authSlice';
import useTheme from '../hooks/useTheme';

export const ThemeContext = React.createContext(null);

export const ThemeProvider = ({ children }) => {
  const user = useSelector(selectUser);
  const isDarkMode = useSelector((state) => state.ui.isDarkMode);

  const tenantIdForApi = user ? user.tenantId : null;
  const theme = useTheme(tenantIdForApi, { skipApiCall: !user });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', !!isDarkMode);

    if (theme.cssVariables) {
      Object.entries(theme.cssVariables).forEach(([prop, value]) => {
        try {
          root.style.setProperty(prop, value);
        } catch (e) {
          // silent
        }
      });
    }

    return () => {
      if (theme.cssVariables) {
        Object.keys(theme.cssVariables).forEach((prop) => {
          try {
            root.style.removeProperty(prop);
          } catch (e) {
            // silent
          }
        });
      }
    };
  }, [isDarkMode, theme.cssVariables]);

    // Simple loading state without circular dependency 
  if (user && theme.isLoading) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 dark:bg-gray-900/80">
        <div className="flex flex-col items-center">
          <div className="h-12 w-12 rounded-full border-4 border-t-green-500 border-gray-200 dark:border-gray-600 animate-spin" />
        </div>
      </div>
    );
  }

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => {
  const context = React.useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeContext, bir ThemeProvider içinde kullanılmalıdır');
  }
  return context;
};

export default ThemeProvider;